<div class="container">
  <h1>Es tut uns leid.</h1>
  <p>Die von Ihnen aufgerufene Seite konnte nicht gefunden werden.</p>
  <a routerLink="/list" mat-raised-button color="accent">Zurück zur Startseite</a>
</div>